/**
 * Spec 9.6: a decorative animal emoji assigned deterministically from the student number,
 * never chosen by the child. Twenty of them, indexed by `number % 20` (build spec 8), drawn
 * from the operating system's emoji font so nothing is requested (ADR 0011).
 */

const AVATARS = [
  "🦊",
  "🐼",
  "🐸",
  "🦉",
  "🐙",
  "🦁",
  "🐧",
  "🦋",
  "🐢",
  "🦄",
  "🐨",
  "🦈",
  "🐝",
  "🦜",
  "🐺",
  "🐬",
  "🦔",
  "🐯",
  "🦓",
  "🦩",
] as const;

export function avatarFor(studentNumber: number): string {
  const index = ((studentNumber % AVATARS.length) + AVATARS.length) % AVATARS.length;
  return AVATARS[index] as string;
}
